import { render, staticRenderFns } from "./RelatorioGestaoPcaCroa.vue?vue&type=template&id=3c2dc3be"
import script from "./RelatorioGestaoPcaCroa.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaCroa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports